import React, { useState } from 'react';
import { Form, Select, Input, DatePicker, Upload, Button, message } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import api from '../../services/api';
import OrgTreeEmployeePicker from './OrgTreeEmployeePicker';
import AttachmentPreviewModal from '../AttachmentPreviewModal';
import { RESIGN_TYPE_OPTIONS } from '../../config/hrConstants';

const MAX_ATTACHMENTS = 9;

export default function ResignationApplyFields({
  showEmployeePicker = true,
  onEmployeeSelect,
  attachments = [],
  onAttachmentsChange
}) {
  const [uploading, setUploading] = useState(false);
  const [previewItem, setPreviewItem] = useState(null);

  const handleUpload = async (file) => {
    if (attachments.length >= MAX_ATTACHMENTS) {
      message.warning(`附件最多上传 ${MAX_ATTACHMENTS} 个`);
      return Upload.LIST_IGNORE;
    }
    try {
      setUploading(true);
      const fd = new FormData();
      fd.append('file', file);
      const res = await api.post('/hr/processes/resignation/upload', fd, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      if (res.data.success) {
        onAttachmentsChange?.([...attachments, res.data.data]);
        message.success('附件已上传');
      }
    } catch (e) {
      message.error(e.response?.data?.message || '附件上传失败');
    } finally {
      setUploading(false);
    }
    return Upload.LIST_IGNORE;
  };

  const handleRemove = (file) => {
    const path = file.response?.file_path || file.url;
    onAttachmentsChange?.(attachments.filter((item) => item.file_path !== path));
  };

  const handlePreview = (file) => {
    const data = file.response || attachments.find((item) => item.file_path === file.uid);
    const path = data?.file_path;
    if (!path) return;
    setPreviewItem({
      path,
      name: data?.file_name || file.name || '附件'
    });
  };

  const fileList = attachments.map((item, index) => ({
    uid: item.file_path || String(index),
    name: item.file_name || `附件${index + 1}`,
    status: 'done',
    response: item
  }));

  return (
    <>
      {showEmployeePicker && (
        <Form.Item name="employee_id" label="选择员工" rules={[{ required: true, message: '请选择员工' }]}>
          <OrgTreeEmployeePicker processType="resignation" onEmployeeSelect={onEmployeeSelect} />
        </Form.Item>
      )}

      <Form.Item name="resign_type" label="离职类型" rules={[{ required: true, message: '请选择离职类型' }]}>
        <Select options={RESIGN_TYPE_OPTIONS} placeholder="请选择离职类型" />
      </Form.Item>

      <Form.Item name="reason" label="离职原因">
        <Input.TextArea rows={2} placeholder="选填" />
      </Form.Item>

      <Form.Item name="effective_date" label="离职日期（最后工作日）" rules={[{ required: true, message: '请选择离职日期' }]}>
        <DatePicker style={{ width: '100%' }} placeholder="请选择离职日期" />
      </Form.Item>

      <Form.Item label="附件">
        <Upload
          fileList={fileList}
          beforeUpload={handleUpload}
          onRemove={handleRemove}
          onPreview={handlePreview}
          showUploadList={{ showPreviewIcon: true, showRemoveIcon: true }}
          multiple
          disabled={uploading}
        >
          <Button icon={<UploadOutlined />} loading={uploading} disabled={attachments.length >= MAX_ATTACHMENTS}>
            上传附件
          </Button>
        </Upload>
      </Form.Item>

      <AttachmentPreviewModal
        item={previewItem}
        open={Boolean(previewItem)}
        onClose={() => setPreviewItem(null)}
      />

      <Form.Item name="remark" label="备注">
        <Input.TextArea rows={2} placeholder="选填" />
      </Form.Item>
    </>
  );
}
